import type { PropsOf } from "@emotion/react";
import type { StyledComponent } from "@emotion/styled";
import styled from "@emotion/styled";

import {
  FONT_WEIGHT_NORMAL,
  FONT_WEIGHT_SEMI_BOLD,
  Form,
  FormRow,
  SkiliticsIcon,
  ToggleButton,
  ToggleButtonGroup,
} from "@skilitics/designer-ui-components";

export const FormBody = styled.div`
  overflow: hidden;
`;

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 30px;

  ${FormBody} {
    flex: 1 1 100%;
  }

  ${FormRow} {
    margin-block-end: 0;
  }
`;

export const Filter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  width: 100%;

  padding-block-end: 15px;
`;

export const FilterHeading = styled.span`
  font-size: ${({ theme }) => theme.fontSize};
  font-weight: ${FONT_WEIGHT_SEMI_BOLD};

  user-select: none;
`;

export const FilterButtonGroup: StyledComponent<PropsOf<typeof ToggleButtonGroup>> = styled(ToggleButtonGroup)``;

export const FilterIcon: StyledComponent<PropsOf<typeof SkiliticsIcon>> = styled(SkiliticsIcon)`
  opacity: 0.25;
`;

export const FilterButton: StyledComponent<PropsOf<typeof ToggleButton>> = styled(ToggleButton)`
  justify-content: flex-start;
  gap: 10px;

  color: ${({ theme }) => theme.generalTextIcon};

  border: none;
  border-radius: 0;
  padding: 5px;

  font-size: ${({ theme }) => theme.fontSize};
  font-weight: ${FONT_WEIGHT_NORMAL};
  text-transform: none;

  &:hover {
    color: ${({ theme }) => theme.primaryStrong};
  }

  &[class*="selected"] {
    color: ${({ theme }) => theme.primaryStrong};
    background-color: inherit;
  }

  &[class*="selected"]:hover {
    background-color: inherit;
  }

  &[class*="selected"] ${FilterIcon} {
    opacity: 1;
  }
`;

export const ScrollableContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  width: 100%;
  min-width: 276px;

  overflow-y: auto;
  padding: 15px 20px 0;
`;
